import { render, staticRenderFns } from "./LongQuestion.vue?vue&type=template&id=fbc39d58"
import script from "./LongQuestion.vue?vue&type=script&lang=js"
export * from "./LongQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports